export default __webpack_public_path__ + "static/media/03.b993a2dc.webp";